/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ManualCaptureOrigin = {
    Pi: 'pi',
    Cloud: 'cloud',
} as const;
export type ManualCaptureOrigin = typeof ManualCaptureOrigin[keyof typeof ManualCaptureOrigin];


export function instanceOfManualCaptureOrigin(value: any): boolean {
    for (const key in ManualCaptureOrigin) {
        if (Object.prototype.hasOwnProperty.call(ManualCaptureOrigin, key)) {
            if (ManualCaptureOrigin[key as keyof typeof ManualCaptureOrigin] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ManualCaptureOriginFromJSON(json: any): ManualCaptureOrigin {
    return ManualCaptureOriginFromJSONTyped(json, false);
}

export function ManualCaptureOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualCaptureOrigin {
    return json as ManualCaptureOrigin;
}

export function ManualCaptureOriginToJSON(value?: ManualCaptureOrigin | null): any {
    return value as any;
}

export function ManualCaptureOriginToJSONTyped(value: any, ignoreDiscriminator: boolean): ManualCaptureOrigin {
    return value as ManualCaptureOrigin;
}

